export { default as Slide, SlideProps } from '@material-ui/core/Slide'
export { default as Fade, FadeProps } from '@material-ui/core/Fade'
export * from './Carousel'
